import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAuth } from '@/common/routes/requireAuth'

export const Route = createFileRoute('/app/organizations/$organizationId/builder/$docbuilderSlug')({
  beforeLoad: ({ context }) => {
    requireAuth(context)
  },
  component: RouteComponent,
})

function RouteComponent() {
  // Layout route - child routes render in Outlet
  return <Outlet />
}
